import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';
import { getIsInTestGroup } from 'libs/ab';
import { cookieManager } from 'libs/cookie';
import { CookieKeys } from 'types/common';
import { actions } from 'actions';
import { featureFlagsSelector } from 'selectors/config';
import { useAuthenticationState } from 'hooks/authenticationState';
import { loginWith2FARecomendationSelector } from 'selectors/loginWith2FARecomendation';
import { UserDirectoryOTPType } from '../../../__generated__/globalTypes';
import { LoginWith2FARecomendationQuery } from './__generated__/LoginWith2FARecomendationQuery';
import * as query from './query.gql';

export const useLoginWith2FARecomendation = () => {
  const is2faAuthNotifyHidden = cookieManager.get(CookieKeys.LoginWith2FARecomendationHiddenAt);
  const isAuthenticated = useAuthenticationState();
  const isInTestGroup = getIsInTestGroup('LoginWith2FARecomendation');

  const { data } = useQuery<LoginWith2FARecomendationQuery>(query, {
    skip: !isAuthenticated,
  });

  const is2FADisabled = data?.userDirectory.OTPStatus.type === UserDirectoryOTPType.OTP_DISABLED;

  const isRecomendationVisible =
    useSelector(loginWith2FARecomendationSelector) && !is2faAuthNotifyHidden;

  const { loginWith2FARecomendation: featureFlag } = useSelector(featureFlagsSelector);

  const dispatch = useDispatch();

  const setIsVisible = () => dispatch(actions.hideLoginWith2FARecomendation());

  const hideRecomendation = () => {
    cookieManager.set(CookieKeys.LoginWith2FARecomendationHiddenAt, `${Date.now()}`, {
      expires: moment().add(1, 'd').toDate(),
    });
    setIsVisible();
  };

  return {
    isRecomendationVisible:
      isInTestGroup && featureFlag && isAuthenticated && is2FADisabled && isRecomendationVisible,
    hideRecomendation,
  };
};
